// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2d97e7f6","33":"329959d7","236":"a4d131ff","320":"ac952db2","443":"3ac324d7","563":"26a9b4f3","577":"757729a8","740":"a6640ce6","755":"aead3503","777":"0c2e5fdd","780":"9aefc66e"}[chunkId] + ".chunk.js";
};